<template>
  <div class="card-contents" @click="$emit('showDetail', contentsDetail)">
    <img :src="getContentsThumbnailPath(contentsDetail.contentid, showScreen, gridType) " :alt="contentsDetail.content_name">
    <div class="layer"></div>
    <div class="content-name font28">{{ contentsDetail.content_name }}</div>
  </div>
</template>

<script>
import common from '@/mixin/common';

export default {
  name: 'storeListItem',
  data: function () {
    return {
      showScreen: 'StoreListItem',
    }
  },
  props: {
    contentsDetail: Object,
    gridType: String,
  },
  mixins: [
    common,
  ],
};
</script>

<style lang="scss" scoped>
@import 'src/assets/style/common';
@import 'src/assets/style/store_list';
</style>



// WEBPACK FOOTER //
// StoreListItem.vue?4e16a83e